import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toast"]

  // Called when new toast is added via Turbo Stream
  toastTargetConnected(toast) {
    $(toast).toast('show')
  }
}
